import { render, staticRenderFns } from "./NewBaseFrame.vue?vue&type=template&id=38c8d62b&scoped=true&"
import script from "./NewBaseFrame.vue?vue&type=script&lang=js&"
export * from "./NewBaseFrame.vue?vue&type=script&lang=js&"
import style0 from "./NewBaseFrame.vue?vue&type=style&index=0&id=38c8d62b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8d62b",
  null
  
)

export default component.exports